// Lucide icon: link (https://lucide.dev/icons/link)
import { Link } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconLink = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Link />
    </IconComponentStyled>
  )
}
